// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"9210e52e","339":"56013c5e","368":"6aae0710","488":"9ab3554e","538":"feb8f3d3","687":"3b093b45","978":"69d82b6f"}[chunkId] + ".chunk.js";
};